import { IPerson } from "../../interfaces";
import { IAOPRanking } from "../../interfaces/models/IAOPRanking";

export const AOPRankingEmpty: IAOPRanking = { 
    id: "",
    firm: '',
    person: {} as IPerson,
    matches: 0,
    ranks: []
 };